import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface StepperHeaderProps {
  title: string;
  subtitle: string;
}

const StepperHeader: React.FC<StepperHeaderProps> = ({ title, subtitle }) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box ml={smScreen ? 0 : 8} mt={2} mb={2}>
      <Typography
        fontFamily="Lufga"
        fontSize={smScreen ? '24px' : '32px'}
        fontWeight="500"
        color="var(--primary-blue)"
      >
        {title}
      </Typography>

      <Typography
        fontFamily="Lufga"
        fontWeight="400"
        fontSize="20px"
        color="var(--primary-navy)"
        mt={2}
        mb={2}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default StepperHeader;
